import React from "react";
import shared from "../shared.module.scss";
import styles from "./ProteinCalculator.module.scss";
import { InfoCard } from "../InfoCard";
import { SourceInfo } from "../SourceInfo";
import { Disclaimer } from "../../components/Disclaimer";
import { DISCLAIMER_TEXT } from "../constant";

export const FinalSummaryView = ({ weight, patientTypeLabel, recommended, dailyProteinFood, supplementResult }) => {
  return (
    <div className={styles.section}>
      <div className={shared.summaryRow}>
        <div className={shared.summaryItem}>
          <span className={shared.summaryItemLabel}>Weight :</span>
          <span className={shared.summaryItemValue}>{weight} kg</span>
        </div>
        <div className={shared.summaryItem}>
          <span className={shared.summaryItemLabel}>Type of Patient :</span>
          <span className={shared.summaryItemValue}>{patientTypeLabel}</span>
        </div>
      </div>

      <InfoCard heading="Recommended Daily Protein Range" value={recommended.recommended} />
      <InfoCard heading="Daily Protein From Food" value={supplementResult.dailyProtein || `${dailyProteinFood} grams/day`} />
      <InfoCard heading="Supplement Recommendation" value={supplementResult.supplement} variant="emphasis" />

      <SourceInfo source={"Npaip guidelines"} webUrl={"https://www.pubmed/ncbi.gov"} />

      <Disclaimer>{DISCLAIMER_TEXT}</Disclaimer>
    </div>
  );
};
